import { useCallback } from "react"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useNavigate } from "react-router-dom"

import { APP_STATUS, updateAppStatus } from "utils/electron"

import { useHome } from "hooks/home/useHome"
import { useTranslation } from "providers/i18n"

import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { PageCard } from "components/card"
import { NearMeIcon } from "components/icons"
import { SidebarMenu } from "extensions/iconsiam/components/navigation/kiosk-h/SidebarMenu"
import { ContentWithAside } from "layouts/kiosk-h"
import { formbricksTrack } from "extensions/iconsiam/utils"
import { HomeInstructionCards } from "./HomeInstrauctionCard"
import { useHomeMap } from "hooks/home/useHomeMap"
import { useHomeInstructionCards } from "extensions/iconsiam/hooks/home-instruction-cards/useHomeInstructionCards"

export const HomeWithInfosPage = ({
  Layout = ContentWithAside,
  AppNavigation = DefaultAppNavigation,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { venues, defaultRoutePath } = useHome()
  const { enable: instructionCardsEnable } = useHomeInstructionCards()

  useHomeMap(venues)

  const base = theme.components?.[`HomePage`]?.styleOverrides ?? {}
  const infos = theme.components?.[`HomeWithInfosPage`]?.styleOverrides ?? {}
  const {
    pageCard,
    contentContainer,
    actionContainer,
    actionButton,
    welcomeContainer,
    touchToStartText,
    touchToStartIcon,
    homeInstructionCards,
    classicWelcomeContainer,
    classicActionButton,
    classicTouchToStartText,
  } = deepmerge(base, infos)

  const handleClick = useCallback(() => {
    formbricksTrack("touch_to_start_kiosk")
    updateAppStatus(APP_STATUS.ACTIVE)
    navigate(defaultRoutePath)
  }, [navigate, defaultRoutePath])

  return (
    <Layout
      aside={
        <PageCard>
          <SidebarMenu AppNavigation={AppNavigation} />
        </PageCard>
      }
    >
      <PageCard sx={pageCard}>
        <Box sx={contentContainer} className="contentContainer">
          {instructionCardsEnable ? (
            <>
              <HomeInstructionCards sx={homeInstructionCards} />
              <Box sx={welcomeContainer}>
                <Box sx={actionContainer}>
                  <Button sx={actionButton} onClick={handleClick}>
                    <Typography sx={touchToStartText}>{t("START")}</Typography>
                  </Button>
                </Box>
              </Box>
            </>
          ) : (
            <Box sx={classicWelcomeContainer}>
              <Box sx={actionContainer}>
                <Button sx={classicActionButton} onClick={handleClick}>
                  <NearMeIcon sx={touchToStartIcon} />
                  <Typography sx={classicTouchToStartText}>
                    {t("Touch to start")}
                  </Typography>
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </PageCard>
    </Layout>
  )
}
